import React from "react";
import { SiteLayout } from "../components/SiteLayout";

export interface GameLayoutProps {
  children: React.ReactNode;
}

export function GameLayout({ children }: GameLayoutProps) {
  return <SiteLayout>{children}</SiteLayout>;
}
